var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',[_vm._v("1、以電子化取代現有人工作業模式，由學生自行至系統建立個人外語檢定成績資料，並方便學生直接由系統查詢審核結果。"),_c('br'),_vm._v(" 2、透過系統直接辨識各類外語測驗分數所對應的獎勵等級及補助金額，降低填錯的機會。 ")])}]

export { render, staticRenderFns }